/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const inviteUser = /* GraphQL */ `
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input)
  }
`;
export const createCountry = /* GraphQL */ `
  mutation CreateCountry(
    $input: CreateCountryInput!
    $condition: ModelCountryConditionInput
  ) {
    createCountry(input: $input, condition: $condition) {
      id
      code
      name
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateCountry = /* GraphQL */ `
  mutation UpdateCountry(
    $input: UpdateCountryInput!
    $condition: ModelCountryConditionInput
  ) {
    updateCountry(input: $input, condition: $condition) {
      id
      code
      name
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteCountry = /* GraphQL */ `
  mutation DeleteCountry(
    $input: DeleteCountryInput!
    $condition: ModelCountryConditionInput
  ) {
    deleteCountry(input: $input, condition: $condition) {
      id
      code
      name
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createCurrency = /* GraphQL */ `
  mutation CreateCurrency(
    $input: CreateCurrencyInput!
    $condition: ModelCurrencyConditionInput
  ) {
    createCurrency(input: $input, condition: $condition) {
      id
      code
      numcode
      name
      exponent
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateCurrency = /* GraphQL */ `
  mutation UpdateCurrency(
    $input: UpdateCurrencyInput!
    $condition: ModelCurrencyConditionInput
  ) {
    updateCurrency(input: $input, condition: $condition) {
      id
      code
      numcode
      name
      exponent
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteCurrency = /* GraphQL */ `
  mutation DeleteCurrency(
    $input: DeleteCurrencyInput!
    $condition: ModelCurrencyConditionInput
  ) {
    deleteCurrency(input: $input, condition: $condition) {
      id
      code
      numcode
      name
      exponent
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const createState = /* GraphQL */ `
  mutation CreateState(
    $input: CreateStateInput!
    $condition: ModelStateConditionInput
  ) {
    createState(input: $input, condition: $condition) {
      id
      name
      abbreviation
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateState = /* GraphQL */ `
  mutation UpdateState(
    $input: UpdateStateInput!
    $condition: ModelStateConditionInput
  ) {
    updateState(input: $input, condition: $condition) {
      id
      name
      abbreviation
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteState = /* GraphQL */ `
  mutation DeleteState(
    $input: DeleteStateInput!
    $condition: ModelStateConditionInput
  ) {
    deleteState(input: $input, condition: $condition) {
      id
      name
      abbreviation
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const addFormElement = /* GraphQL */ `
  mutation AddFormElement(
    $query: MutationAddFormElementQueryInput
    $body: MutationAddFormElementBodyInput
  ) {
    addFormElement(query: $query, body: $body) {
      name
      attributes
    }
  }
`;
export const updateFormElement = /* GraphQL */ `
  mutation UpdateFormElement(
    $query: MutationUpdateFormElementQueryInput
    $body: MutationUpdateFormElementBodyInput
  ) {
    updateFormElement(query: $query, body: $body)
  }
`;
export const deleteFormElement = /* GraphQL */ `
  mutation DeleteFormElement($params: MutationDeleteFormElementParamsInput!) {
    deleteFormElement(params: $params)
  }
`;
export const addMerchantForm = /* GraphQL */ `
  mutation AddMerchantForm(
    $query: MutationAddMerchantFormQueryInput
    $body: MutationAddMerchantFormBodyInput
  ) {
    addMerchantForm(query: $query, body: $body) {
      merchantCode
      formElements {
        formElement
        sequenceNumber
      }
    }
  }
`;
export const updateMerchantForm = /* GraphQL */ `
  mutation UpdateMerchantForm(
    $query: MutationUpdateMerchantFormQueryInput
    $body: MutationUpdateMerchantFormBodyInput
  ) {
    updateMerchantForm(query: $query, body: $body)
  }
`;
export const deleteMerchantForm = /* GraphQL */ `
  mutation DeleteMerchantForm($params: MutationDeleteMerchantFormParamsInput!) {
    deleteMerchantForm(params: $params)
  }
`;
export const saveMerchantFormData = /* GraphQL */ `
  mutation SaveMerchantFormData(
    $query: MutationSaveMerchantFormDataQueryInput
    $body: MutationSaveMerchantFormDataBodyInput
  ) {
    saveMerchantFormData(query: $query, body: $body) {
      merchantCode
      formDataGUID
      formData
      dateSubmitted
    }
  }
`;
export const addMerchant = /* GraphQL */ `
  mutation AddMerchant(
    $query: MutationAddMerchantQueryInput
    $body: MutationAddMerchantBodyInput
  ) {
    addMerchant(query: $query, body: $body) {
      aliasCode
      name
      slogan
      phoneNumber
      email
      location {
        streetAddress1
        streetAddress2
        countryName
        stateName
      }
    }
  }
`;
export const addMerchantCountry = /* GraphQL */ `
  mutation AddMerchantCountry(
    $query: MutationAddMerchantCountryQueryInput
    $body: MutationAddMerchantCountryBodyInput
  ) {
    addMerchantCountry(query: $query, body: $body) {
      name
      states {
        name
      }
    }
  }
`;
export const deleteMerchant = /* GraphQL */ `
  mutation DeleteMerchant($params: MutationDeleteMerchantParamsInput!) {
    deleteMerchant(params: $params)
  }
`;
export const deleteMerchantCountry = /* GraphQL */ `
  mutation DeleteMerchantCountry(
    $params: MutationDeleteMerchantCountryParamsInput!
  ) {
    deleteMerchantCountry(params: $params)
  }
`;
export const updateMerchant = /* GraphQL */ `
  mutation UpdateMerchant(
    $query: MutationUpdateMerchantQueryInput
    $body: MutationUpdateMerchantBodyInput
  ) {
    updateMerchant(query: $query, body: $body)
  }
`;
export const updateMerchantCountry = /* GraphQL */ `
  mutation UpdateMerchantCountry(
    $query: MutationUpdateMerchantCountryQueryInput
    $body: MutationUpdateMerchantCountryBodyInput
  ) {
    updateMerchantCountry(query: $query, body: $body)
  }
`;
export const createPaymentIntent = /* GraphQL */ `
  mutation CreatePaymentIntent(
    $query: MutationCreatePaymentIntentQueryInput
    $body: MutationCreatePaymentIntentBodyInput
  ) {
    createPaymentIntent(query: $query, body: $body) {
      intentId
      status
    }
  }
`;
export const createPaymentAuthorization = /* GraphQL */ `
  mutation CreatePaymentAuthorization(
    $query: MutationCreatePaymentAuthorizationQueryInput
    $body: MutationCreatePaymentAuthorizationBodyInput
  ) {
    createPaymentAuthorization(query: $query, body: $body) {
      htmlForm
      errors {
        message
      }
    }
  }
`;
export const modifyTransaction = /* GraphQL */ `
  mutation ModifyTransaction(
    $query: MutationModifyTransactionQueryInput
    $body: MutationModifyTransactionBodyInput
  ) {
    modifyTransaction(query: $query, body: $body) {
      TransactionStatus
      Successful
    }
  }
`;
export const onBoardMerchant = /* GraphQL */ `
  mutation OnBoardMerchant(
    $query: MutationOnBoardMerchantQueryInput
    $body: MutationOnBoardMerchantBodyInput
  ) {
    onBoardMerchant(query: $query, body: $body)
  }
`;
export const offBoardMerchant = /* GraphQL */ `
  mutation OffBoardMerchant($params: MutationOffBoardMerchantParamsInput!) {
    offBoardMerchant(params: $params)
  }
`;
export const saveFacCredentials = /* GraphQL */ `
  mutation SaveFacCredentials(
    $query: MutationSaveFacCredentialsQueryInput
    $body: MutationSaveFacCredentialsBodyInput
  ) {
    saveFacCredentials(query: $query, body: $body) {
      isSuccess
      errorMessage
    }
  }
`;

export const updateFacCredentials = /* GraphQL */ `
  mutation UpdateFacCredentials(
    $body: MutationUpdateFacCredentialsBodyInput!
  ) {
    updateFacCredentials(body: $body) {
      isSuccess
      errorMessage
    }
  }
`;
export const createPromoCode = /* GraphQL */`
  mutation CreatePromoCode($body: PromoCodeInput!) {
    createPromoCode(body: $body){
      success 
      error
    }
  }
`;
export const updatePromoCode = /* GraphQL */`
  mutation UpdatePromoCode($id: ID!, $body: PromoCodeInput!) {
    updatePromoCode(id: $id, body: $body){
      success 
      error
    }
  }
`;
export const disablePromoCode = /* GraphQL */`
  mutation DisbalePromoCode($id: ID!) {
    disablePromoCode(id: $id){
      success 
      error
    }
  }
`;
export const enablePromoCode = /* GraphQL */`
  mutation EnablePromoCode($id: ID!) {
    enablePromoCode(id: $id){
      success 
      error
    }
  }
`;
